module.exports = __webpack_public_path__ + "static/common-28a743b490d64a67300b26304cc20f69.png";